import { render, staticRenderFns } from "./HouseAccommodationDetailsFields.vue?vue&type=template&id=4817c502&"
import script from "./HouseAccommodationDetailsFields.vue?vue&type=script&lang=js&"
export * from "./HouseAccommodationDetailsFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VDatePicker,VListItem,VMenu,VTextField})
